export * from "-!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/stylus-loader/index.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./project.list.vue?vue&type=style&index=0&id=24973c23&lang=stylus&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/project/project.list.vue?vue&type=style&index=0&id=24973c23&lang=stylus&scoped=true&
// module id = 806
// module chunks = 2